import { observer } from 'mobx-react-lite';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelTab } from '../components/event-panel-tab';
import { ManageMergedEventsModalButton } from './components/ManageMergedEventsModalButton';
import { MergedEventsTabExistingEvent } from './components/merged-events-tab-existing-event';
import { MergedEventsTabNewEvent } from './components/merged-events-tab-new-event';

export const MergedEventsTab = observer(function MergedEventsTab() {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventId = eventMetadata?.eventId;
    return (
        <EventPanelTab
            title="Merged Events"
            titleTrailingNode={<ManageMergedEventsModalButton eventId={eventId} />}
        >
            {eventId ? (
                <MergedEventsTabExistingEvent eventId={eventId} />
            ) : (
                <MergedEventsTabNewEvent />
            )}
        </EventPanelTab>
    );
});
